// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Hsthi","employee-header-item":"Header_employee-header-item__FodTF"};